import React from 'react';

const CopyIcon = ({
  className,
  height = '24',
  width = '22',
  title = 'Copy Icon',
  onClick
}) => (
  <svg
    className={className}
    width={height}
    height={width}
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    onClick={onClick}
  >
    <title>{title}</title>
    <path
      d='M11.375 9.1875H6.125C5.88438 9.1875 5.6875 8.99063 5.6875 8.75V1.75C5.6875 1.50937 5.88438 1.3125 6.125 1.3125H9.95586L11.8125 3.16914V8.75C11.8125 8.99063 11.6156 9.1875 11.375 9.1875ZM6.125 10.5H11.375C12.3402 10.5 13.125 9.71523 13.125 8.75V3.16914C13.125 2.82188 12.9855 2.48828 12.7395 2.24219L10.8855 0.385547C10.6395 0.139453 10.3059 0 9.95859 0H6.125C5.15977 0 4.375 0.784766 4.375 1.75V8.75C4.375 9.71523 5.15977 10.5 6.125 10.5ZM2.625 3.5C1.65977 3.5 0.875 4.28477 0.875 5.25V12.25C0.875 13.2152 1.65977 14 2.625 14H7.875C8.84023 14 9.625 13.2152 9.625 12.25V11.375H8.3125V12.25C8.3125 12.4906 8.11562 12.6875 7.875 12.6875H2.625C2.38437 12.6875 2.1875 12.4906 2.1875 12.25V5.25C2.1875 5.00938 2.38437 4.8125 2.625 4.8125H3.5V3.5H2.625Z'
      fill='#343A40'
    />
  </svg>
);

export default CopyIcon;
